module.exports = __webpack_public_path__ + "static/media/confirm-employee-success.437e47d1.svg";